// extracted by mini-css-extract-plugin
export default {"photo_folder_card":"PhotoFolderCard_photo_folder_card__ndWf+","photo_folder_card_full_view":"PhotoFolderCard_photo_folder_card_full_view__BVtgG"};